/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import closeIcon from '../../../../assets/images/x_icon_black.svg';

import './index.scss';

Modal.setAppElement('#root');

class InstallLayover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { modelopen, closeStaffModal, updatStaffMap } = this.props;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeStaffModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title">Are you sure?</div>
              <button className="modal-close" onClick={closeStaffModal}>
                <img src={closeIcon} alt="Close" />
              </button>
              <div className="modal-description">
                You are about to delete a staff mapping. This cannot be undone.
              </div>
              <p className="note">Please click the <strong>SAVE </strong> button after all your updates to persist the changes</p>
              <div className="actions">
                <button className="btn btn--primary btn--lg" onClick={() => updatStaffMap({}, 'Delete')}>DELETE</button>
                <button className="btn btn--secondary btn--lg" onClick={closeStaffModal}>CANCEL</button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default InstallLayover;
